import { axios, createFormData, handleError } from '../axios';

export const restorePost = (formData) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/post/restore', createFormData(formData))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
